import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';
import './translations/i18n';
import App from './App';
import * as Sentry from '@sentry/react';
import { registerAudioUnlock } from './helpers/sound';
if (!window.location.host.includes('kvc.ddev.site')) {
    const host = window.location.host;
    const environment = host.includes('stage.') ? 'staging' : 'production';
    Sentry.init({
        dsn: 'https://e68b764d1b8f074e037fa91fee6c6fd4@o4509570031484928.ingest.de.sentry.io/4509570033123408',
        environment,
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: false,
                networkDetailAllowUrls: ['/_api/admin/rallies', '/_api/admin/themes', '/_api/target-groups', '/_api/rallies', '/_api/game-sessions/status', '/_api/task-time-logs']
            })
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['https://stage.kvc.kreativrudel.it', 'https://stage.compass-app.eu'],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}
registerAudioUnlock();
createRoot(document.getElementById('root')).render(_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        })
            .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
    });
}
